export const HOST =
  window.environment.environment ===  'PRODUCTION' ? 'https://traffixsentinel-api.azurewebsites.net' :
  window.environment.environment ===  'DEMO' ? 'https://traffixsentinel-api-demo.azurewebsites.net' : 
  window.environment.environment ===  'STAGING' ? 'https://traffixsentinel-api-staging.azurewebsites.net' : 
  window.environment.environment ===  'DEV' ? 'https://traffixsentinel-api-dev.azurewebsites.net' : 
  window.environment.environment ===  'LOCAL' ? 'https://localhost:5001' : 
  'https://traffixsentinel-api-dev.azurewebsites.net';